import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1.6V5.6a6.4 6.4 0 0 1 0 12.8Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render };